<!-- 由 suu 创建于 2025-03-14 星期五 -->
<template>
  <div class="activity-project">
    <AppNavBar v-if="isApp" @share="bindShare" />
    <div v-if="state">
      <!-- 阶段三 报名成功 （挑战期、挑战失败、挑战成功）-->
      <projectThree :info="info" v-if="state == 3"></projectThree>
      <!-- 阶段二 预报名（已经预报名等待教练上传资料正式报名开启挑战） -->
      <projectTwo
        :info="info"
        v-else-if="state == 2"
        @finish="bindFinish"
      ></projectTwo>
      <!-- 阶段一 未报名（无资格、还未预报名、预报名过期） -->
      <projectOne :info="info" @success="getActivityInfo" v-else></projectOne>
    </div>
    <vLoading v-else></vLoading>
    <van-popup class="tip-popup" v-model="showToast">
      <ActivityToast
        @confirm="bindConfirmTip"
        @cancel="bindCancelTip"
        :title="toastOptions.title"
        :message="toastOptions.message"
        :confirmText="toastOptions.confirmText"
        :showCancel="toastOptions.showCancel"
      />
    </van-popup>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindShareCancel"
      @select="bindShareSelect"
    />
  </div>
</template>

<script>
import BetterweWxApi from '@/components/wx/control.js'
import { eventObj } from '@/components/app/share/share-method.js'
import AppNavBar from './components/nav-bar.vue'
import ActivityToast from './components/toast.vue'
import projectOne from './components/project-one.vue'
import projectTwo from './components/project-two.vue'
import projectThree from './components/project-three.vue'
import ShareComponent from '@/components/app/share/share.vue'
export default {
  name: 'activity-project',

  components: {
    AppNavBar,
    ActivityToast,
    projectOne,
    projectTwo,
    projectThree,
    ShareComponent
  },

  props: {},

  data() {
    return {
      info: null,
      state: null, // 1 阶段一  2 阶段二  3 阶段三
      showToast: false,
      showShare: false,
      shareOptions: {
        title: '我正在参与健萌project挑战',
        desc: '快来和我一起挑战赢好礼吧！',
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png'
      },
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ],
      toastOptions: {
        title: '提示',
        message: '很抱歉！您主教练的挑战名额已满，期待您的下次参与~'
      },
      qrcodeUrl: ''
    }
  },

  computed: {
    isApp() {
      return this.$betterwe.isApp()
    }
  },

  watch: {},

  created() {
    this.setQrcodeUrl()
    this.getActivityInfo()
    window.onPageResumed = () => {
      this.getActivityInfo()
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    setShareOptions() {
      let shareOptions = Object.assign({}, this.shareOptions)
      if (this.info?.state !== 3) {
        shareOptions.title = `你的教练向你发起对赌`
        shareOptions.desc = '开启project挑战'
      }
      shareOptions.link = this.qrcodeUrl
      BetterweWxApi.setShareData(shareOptions, shareOptions)
    },
    setQrcodeUrl() {
      let env = this.$http.curEv()
      if (env === 'pro') {
        this.qrcodeUrl =
          'https://vue.gymcity.com.cn/?path=app-trans-h5&toUrl=activity-project&tfrom=app'
      } else {
        this.qrcodeUrl =
          'https://test.gymcity.com.cn/?path=app-trans-h5&toUrl=activity-project&tfrom=app'
      }
    },
    // 获取活动信息
    async getActivityInfo() {
      let res = await this.$http
        .get('member/activity.ActProject?a=getActInfo', {})
        .catch((err) => {
          this.$toast('异常错误')
          this.state = 1
        })
      if (res) {
        res = res.data
        if (res && res.code === 200) {
          this.info = res.data
          this.setActivityState(this.info)
        } else {
          this.state = 1
        }
      } else {
        this.state = 1
      }
      this.setShareOptions()
    },
    //设置活动状态
    setActivityState(info) {
      // 已预报名但教练名下已开启挑战人数已经大于等于2人 则弹窗并提醒
      if (info.state === 2) {
        //是否开始挑战
        let isStartChallenge =
          new Date(info.server_time.replace(/-/g, '/')).getTime() -
            new Date(info.act_start_tiem.replace(/-/g, '/')).getTime() >=
          0
        if (info.count >= 2) {
          this.toastOptions = {
            title: '提示',
            message: '很抱歉！您主教练的挑战名额已满，<br/>期待您的下次参与~',
            showCancel: false
          }
          this.showToast = true
          this.state = 1
        } else if (isStartChallenge && !info.e_type) {
          //活动开始后教练还没有填写
          this.state = 1
          this.toastOptions = {
            title: '提示',
            message: '您已报名，正在等待教练上传挑战书~',
            showCancel: false
          }
          this.showToast = true
        } else {
          this.state = this.info.state
        }
      } else if (info.state == 3 && !this.isApp) {
        //如果挑战开始并且不再app
        this.state = 2
      } else {
        this.state = info.state
      }
    },
    bindConfirmTip() {
      this.showToast = false
    },
    bindCancelTip() {
      this.showToast = false
    },
    bindShare() {
      this.showShare = true
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-分享按钮点击-${this.$route.query.tfrom || ''}`,
        from_id: 250319
      })
    },
    bindShareCancel() {
      this.showShare = false
    },
    //活动报名倒计时结束触发
    bindFinish() {
      this.getActivityInfo()
    },
    bindShareSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      if (this.info?.state !== 3) {
        shareOptions.title = `你的教练向你发起对赌`
        shareOptions.desc = '开启project挑战'
      }
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.tip-popup {
  border-radius: 10px;
}
.activity-project {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
}
</style>
